.panel {
	background: var(--surface-card);
	border-radius: var(--radius-lg);
	padding: var(--space-5);
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
	/* The day column holds an explicit height, so on a screen too short for
	   it the panel scrolls rather than pushing Cancel/Add off the dialog. */
	max-height: 100%;
	overflow-y: auto;
	box-sizing: border-box;
}

.heading {
	margin: 0;
	font-size: 1rem;
	font-weight: 600;
}

/* The recipe being planned, so the panel says what's about to be written. */
.subheading {
	margin: 2px 0 0;
	font-size: 0.875rem;
	color: var(--ink-muted);
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.error {
	margin: 0;
	font-size: 0.8125rem;
	line-height: 1.4;
	text-wrap: pretty;
	color: var(--accent-rose);
}

.actions {
	display: flex;
	gap: var(--space-2);
	justify-content: flex-end;
}

.primary,
.secondary {
	border-radius: var(--radius-sm);
	padding: var(--space-2) var(--space-4);
	font: inherit;
	font-weight: 600;
	cursor: pointer;
}

.primary {
	background: var(--accent-sage);
	color: #fff;
	border: none;
}

.secondary {
	background: none;
	color: var(--ink-muted);
	border: 1px solid var(--border);
}

.primary:disabled,
.secondary:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
